import React from "react";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";

interface UpdateConfirmDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const UpdateConfirmDialog: React.FC<UpdateConfirmDialogProps> = ({
  open,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
      <DialogTitle>
        {t("paygap.employeeData.dialog.confirmUpdate.title")}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          {t("paygap.employeeData.dialog.confirmUpdate.message")}
        </Typography>

        <Alert severity="warning" sx={{ mt: 2 }}>
          <Typography variant="body2">
            <strong>{t("paygap.employeeData.dialog.confirmUpdate.warning")}</strong>
          </Typography>
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="secondary">
          {t("paygap.employeeData.dialog.confirmUpdate.cancel")}
        </Button>
        <Button onClick={onConfirm} variant="contained" color="primary">
          {t("paygap.employeeData.dialog.confirmUpdate.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
